import type { Language } from '@bruce/components'

export const DEFAULT_LANGUAGE = 'en'
export const ALTERNATIVE_LANGUAGES: Language[] = ['sv', 'nb', 'da']

export const AVAILABLE_LANGUAGES: Language[] = [
  DEFAULT_LANGUAGE,
  ...ALTERNATIVE_LANGUAGES,
]

export const LOCALES = {
  en: 'en_US',
  sv: 'sv_SE',
  nb: 'nb_NO',
  da: 'da_DK',
} as const

export const ADYEN_LOCALES = {
  en: 'en-US',
  sv: 'sv-SE',
  nb: 'no-NO',
  da: 'da-DK',
} as const

export const LANGUAGE_NAMES = {
  en: 'English',
  sv: 'Svenska',
  nb: 'Norsk',
  da: 'Dansk',
} as const

export const DEFAULT_LOCALE = LOCALES[DEFAULT_LANGUAGE]
export const ALTERNATIVE_LOCALES = [LOCALES.sv, LOCALES.nb, LOCALES.da] as const
